var WDN = WDN || {};

if (typeof WDN.Header === "undefined") {
  WDN.Header = (function () {
    var init, getHeightVariable, setHeightVariable;

    // handlers
    var onResize;

    // dependencies
    var CSSVariable = WDN.CSSVariable;

    // nodes
    var nodes = {
      header: document.querySelector("[data-header]"),
    };

    setHeightVariable = function (newValue) {
      if (typeof newValue === "undefined") return;
      CSSVariable.set({
        name: "--header-height",
        value: newValue,
      });
    };

    getHeightVariable = function () {
      return parseFloat(WDN.CSSVariable.get("--header-height"));
    };

    onResize = function () {
      setHeightVariable(nodes.header.getBoundingClientRect().height + "px");
    };

    init = function () {
      if (!nodes.header) {
        setHeightVariable("0px");
        return;
      }

      setHeightVariable(nodes.header.getBoundingClientRect().height + "px");

      // Event coming from main.js
      window.addEventListener("window:resize", onResize);

      // Add initialized class
      document.body.classList.add("header--initialized");
    };

    init();
    return {};
  })();
}
